import { createSelector } from 'reselect';

export const selectUserData = createSelector(
  (state) => state.common,
  (common) => common
);

export const selectUserGoods = createSelector(selectUserData, (data) => data.goods.filter((item) => item.count > 0));

export const selectTeam = createSelector(selectUserData, (data) => {
  return data.teams.find((item) => item.id === data.currentTeam) || '';
});

export const selectUserAvatar = createSelector(selectUserData, selectTeam, (data, team) => ({
  avatar: team ? team.avatar : data.avatar,
}));

export const selectTeamLicenses = createSelector(selectUserData, selectTeam, (data, team) => {
  if (team) {
    return {
      licenseCount: team.licenseCount,
      licenseExpire: team.licenseExpire,
    };
  } else {
    return {
      licenseExpire: data.tariff.expire,
    };
  }
});

export const selectFreeSpace = createSelector(selectUserData, selectTeam, (data, team) => {
  if (team) {
    return {
      hasQuota: team.hasQuota,
      quotaLimit: team.quotaLimit,
      quotaUsage: team.quotaUsage,
      quotaFree: team.quotaFree,
      quotaFreePercent: team.quotaFreePercent,
    };
  } else {
    return {
      hasQuota: data.hasQuota,
      quotaLimit: data.quotaLimit,
      quotaUsage: data.quotaUsage,
      quotaFree: data.quotaFree,
      quotaFreePercent: data.quotaFreePercent,
    };
  }
});
